import { styled } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';

export const CustomAccordion = styled(
    (props: AccordionProps) => (
        <MuiAccordion disableGutters elevation={0} square {...props} />
    ),
    { shouldForwardProp: (prop) => prop !== 'nodeStatus' }
)<{ nodeStatus: string }>(({ nodeStatus }) => ({
    '&:before': {
        display: 'none',
    },
    borderRadius: 12,
    background:
        nodeStatus === 'in_review'
            ? 'linear-gradient(210deg, rgba(89, 184, 202, 0.40) 8.33%, rgba(204, 255, 149, 0.40) 125.21%)'
            : 'linear-gradient(210deg, rgba(83, 97, 220, 0.40) 8.33%, rgba(89, 184, 190, 0.40) 125.21%)',
    // boxShadow: '9px 8px 41px 0px rgba(0, 0, 0, 0.20)',
}));
